import { render } from "./OptionSuiviModale.vue?vue&type=template&id=227fbcdf&scoped=true&ts=true"
import script from "./OptionSuiviModale.vue?vue&type=script&lang=ts"
export * from "./OptionSuiviModale.vue?vue&type=script&lang=ts"

import "./OptionSuiviModale.vue?vue&type=style&index=0&id=227fbcdf&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-227fbcdf"]])

export default __exports__